import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductStack } from './ProductStack';

/** Checkout de ImpulTienda · tienda Vivencia Ready. */
const CHECKOUT_URL = 'https://vivencia-ready.impultienda.ar/checkout';
const included = ['6 complete volumes, 300 pages', '84 ready-to-run Vivencia Plans (VP-01–VP-84)', '18 printable worksheets', '5 instant-use bonuses', 'Newcomer & deepening versions in every plan', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="topo-light w-full bg-paper-dark text-pine" data-id="element-158" data-mp="25s7vv92loy1g">
      <div className="mx-auto max-w-2xl px-5 py-14 sm:py-20" data-id="element-159" data-mp="20s3b36unth5f">
        <div className="text-center" data-id="element-160" data-mp="3h74mgnefnvax">
          <p className="eyebrow text-ember-deep" data-id="element-161" data-mp="3h63amgplf4s5">Complete package</p>
          <h2 id="pricing-heading" className="trail-underline mt-3 font-display text-[30px] leading-tight text-pine sm:text-5xl" data-id="element-162" data-mp="3c8tcmco51ksp">
            A full year of classes, workshops and retreats
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-paper-dark bg-white shadow-card" data-id="element-163" data-mp="4rb1m1ab9lvj">
          <div className="bg-forest px-5 py-5 text-center" data-id="element-164" data-mp="9q5rtoalycpo">
            <h3 className="font-display text-xl text-paper sm:text-2xl" data-id="element-165" data-mp="eqaclqijttlp">
              Vivencia Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-bold text-ember" data-id="element-166" data-mp="3d6uq6n01eg49">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-167" data-mp="3n7es7rvdronj">
            <div className="rounded-2xl bg-forest-deep px-3 pb-4 pt-5" data-id="element-168" data-mp="3n6d9r2c1bzvs">
              <ProductStack data-id="element-169" data-mp="3ry3lncqmevpb" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-170" data-mp="3rzy7qudmotuz">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-[15px]" data-id="element-171" data-mp="2ugd8ddgqt4xo">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-moss-soft" data-id="element-172" data-mp="2zfzl7lsnsj5y">
                    <CheckIcon className="h-3 w-3 text-moss-deep" aria-hidden="true" data-id="element-173" data-mp="2mhrv7upmds6a" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-paper-dark pt-6 text-center" data-id="element-174" data-mp="318in12r7or9e">
              <p className="text-[13px] text-pine-soft" data-id="element-175" data-mp="2w8d1837mhyz8">
                Regular price{' '}
                <span className="text-pine-muted line-through" data-id="element-176" data-mp="28iinzkje68eg">$69 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-177" data-mp="23kgv67w5yups">
                <span className="mt-2.5 font-display text-3xl" data-id="element-178" data-mp="2iggb24pilz5h">$</span>
                <span className="font-display text-6xl leading-[0.9] sm:text-7xl" data-id="element-179" data-mp="2dhd6smhczwyk">
                  27
                </span>
                <span className="mt-3 text-[13px] font-bold text-pine-muted" data-id="element-180" data-mp="3tuk3h6ggff8f">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-181" data-mp="3oycz3i3pibsl">
                <span className="rounded border border-ember bg-ember px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine" data-id="element-182" data-mp="9lws0nw6y2r">
                  Save $42
                </span>
                <span className="rounded border border-paper-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine-soft" data-id="element-183" data-mp="3ngelvqj26y3e">
                  One-time payment
                </span>
                <span className="rounded border border-paper-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine-soft" data-id="element-184" data-mp="j26dyku8beqq">
                  Lifetime access
                </span>
              </div>

              <p className="mt-4 text-sm text-pine-soft" data-id="element-185" data-mp="a8b8tct3xob3">
                That&apos;s less than 35¢ a class.
              </p>

              <CtaButton href={CHECKOUT_URL} className="mt-4" data-id="element-186" data-mp="11zr37t0wofbv">
                Get Vivencia Ready now — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-pine-muted" data-id="element-187" data-mp="16rhh28z1xl81">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-pine-soft" data-id="element-188" data-mp="3f5fkeuyjun5l">
                <li className="flex items-center gap-1.5" data-id="element-189" data-mp="359cjfsffouk8">
                  <LockIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-190" data-mp="359uo9dg5wh3r" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-191" data-mp="1sm8r08wptc7">
                  <ZapIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-192" data-mp="1s44phg06atq" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-193" data-mp="3o86yl2it7x0x">
                  <ShieldCheckIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-194" data-mp="3o6nipd12fnzo" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-pine-muted" data-id="element-195" data-mp="kketk7dto88u">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}